// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Fireball Aim",
  id: "fireball-aim",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire"],
    icon: {
      "backgroundColor": 4264745,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 17,
          "color": 16158805
        }
      ]
    },
  },
};

export default metadata;
